import React, { useRef, useState } from 'react';
import { Wrapper } from '../../components/layout/header';
import styled from 'styled-components';
import Search from 'antd/es/input/Search';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal, Tabs, Tag } from 'antd';
import { Colors } from '../../constant/color';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../navigation/type';
import { downloadPDF, formatCurrency } from '../../utils';
import { PermissionCode, useRole } from '../../hook/use-role';
import { ValuationApi } from '../../apis';
import { Table } from '../../components/table/table';
import TabPane from 'antd/es/tabs/TabPane';
import dayjs from 'dayjs';
import { ValuationDetail } from '../../components/valuation/detail';

type StatusType = 'DRAFT' | 'PENDING' | 'RETURNED' | 'REJECTED' | 'VALUATED' | 'ARCHIVED';
const PAGE_NAME = PermissionCode.VALUATION;

const statusTagColor = (status: StatusType) => {
  switch (status) {
    case 'DRAFT':
      return '';
    case 'PENDING':
      return 'yellow';
    case 'RETURNED':
      return 'blue';
    case 'REJECTED':
      return 'red';
    case 'VALUATED':
      return 'green';
    case 'ARCHIVED':
      return 'gray';
  }
};

const ValuationTaskScreen = () => {
  const [tabIndex, setTabIndex] = useState<string>('1');
  const { check } = useRole();
  const [detail] = useState<any>(undefined);
  const [value, setValue] = useState<string | undefined>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageaApi] = message.useMessage();
  const printRef = useRef<HTMLDivElement>(null);

  const [filters, setFilters] = useState<{
    status?: StatusType;
  }>({
    status: undefined,
  });

  const [statusCount, setStatusCount] = useState<
    {
      code: string;
      name: {
        count: string;
        name: string;
      };
    }[]
  >([]);

  const navigate = useNavigate();

  const onChange = (key: string) => {
    setTabIndex(key);
    setFilters({
      status: key === 'ALL' ? undefined : (key as StatusType),
    });
  };

  const column = columns({
    options: {
      isDelete: check.isDelete(PAGE_NAME),
      isUpdate: check.isEdit(PAGE_NAME),
    },
    setType: async (id: string) => {
      console.log('navigate :', NavigationRoutes.Task_Report_Screen + '/' + id);
      navigate(NavigationRoutes.Task_Report_Screen + '/' + id);
    },
  });

  const onSearch = (value: any) => {
    setValue(value.target.value);
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      const res = await ValuationApi.pdf(detail.id);
      downloadPDF(res.url);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      messageaApi.error(error?.message || 'PDF татахад алдаа гарлаа');
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onCallbackData = (data: any) => {
    setStatusCount(
      Object.keys(data.statusCount).map((key: string) => ({
        code: key,
        name: data.statusCount[key],
      }))
    );
  };

  return (
    <Container className="bg-[white]">
      <div className="flex-col bg-white rounded-[8px] p-5 ">
        <HeaderContainer>
          <div className="flex flex-row justify-between">
            <div className="flex flex-row items-center">
              <label className="text-black">Автомашин үнэлгээний хуудас</label>
            </div>
            {/* <div className="border-l border-[#F3F3F3] flex flex-row gap-[12px] items-center">
              <div className="pl-[17px]">
                <div className="flex flex-row items-center justify-end font-[Manrope] font-normal text-sm leading-5 text-right text-[#0A0A0A]">
                  {me?.lastName} {me?.firstName}
                </div>
                <div className="flex flex-row items-center justify-end font-[Manrope] font-normal text-[12px] leading-4 text-right text-[#6A7282]">
                  Зээлийн мэргэжилтэн
                </div>
              </div>
              <div className="w-[40px] h-[40px] rounded-full opacity-100 flex items-center justify-center bg-[#5869FF]">
                <div className="font-manrope font-normal text-[16px] leading-[24px] tracking-normal text-white">
                  ПТ
                </div>
              </div>
            </div> */}
          </div>
        </HeaderContainer>
        <Wrapper>
          {/* <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
            has been the industry's standard
          </p> */}
          <div className="h-[24px]" />

          <div className="border rounded-[16px] p-[17px] flex flex-col">
            <div className="h-[50px] flex flex-row items-center gap-[12px]">
              <Search
                placeholder="Хайх..."
                onChange={onSearch}
                size="large"
                style={{ width: '30vh' }}
                value={value}
              />
              <Button icon={<CloseCircleOutlined />} size="large" onClick={() => setValue(undefined)}>
                Цэвэрлэх
              </Button>
            </div>
            <div>
              <div className="h-[16px]" />
              <Tabs defaultActiveKey="1" onChange={onChange}>
                {(statusCount || []).map((item) => (
                  <TabPane
                    key={item.code}
                    tab={
                      <div className="flex flex-row items-center gap-[4px]">
                        {item.name.name}
                        <div className="w-[5px]" />
                        <Tag color={statusTagColor(item.code as any)} className="rounded-full">
                          {item?.name?.count}
                        </Tag>
                      </div>
                    }
                  />
                ))}
              </Tabs>
              <Table
                filter={filters}
                columns={column}
                loadData={ValuationApi.list}
                query={value}
                onCallbackData={onCallbackData}
              />
            </div>
          </div>
        </Wrapper>
      </div>

      {detail && (
        <Modal
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          width={850}
          okText="Татах"
          cancelText="Буцах"
          okButtonProps={{ loading: loading }}
        >
          <ValuationDetail
            printRef={printRef}
            action={{
              loading: false,
              payload: detail,
            }}
          />
        </Modal>
      )}
    </Container>
  );
};

const columns: any = ({ setType }: { setType: (id: string) => void }) => [
  {
    title: '#',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    render: (_: any, __: any, index: any) => index + 1,
  },
  {
    title: 'Огноо',
    key: 'date',
    render: (item: any, __: any, index: any) => (
      <div>{dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</div>
    ),
  },
  {
    title: 'Салбар',
    key: 'branch',
    render: (item: any, __: any, index: any) => <div>{item.branch?.name ?? "-"}</div>,
  },
  {
    title: 'Брэнд',
    key: 'brand',
    render: (item: any, __: any, index: any) => <div>{item.carBrand?.name}</div>,
  },
  {
    title: 'Загвар',
    key: 'model',
    render: (item: any, __: any, index: any) => <div>{item.carModel?.name}</div>,
  },
  {
    title: 'Үнэ',
    key: 'price',
    render: (item: any, _: any, index: any) => <label>{formatCurrency(item.priceFinal)}</label>,
  },
  {
    title: 'Үнэлгээний дугаар',
    key: 'sequence',
    width: 100,
    render: (item: any, _: any, index: any) => <label>{item.sequence}</label>,
  },
  // {
  //   title: 'Хаанаас',
  //   key: 'sequence',
  //   render: (item: any, _: any, index: any) => <label>{item.sequence}</label>,
  // },
  // {
  //   title: 'Хаашаа',
  //   key: 'sequence',
  //   render: (item: any, _: any, index: any) => <label>{item.sequence}</label>,
  // },
  {
    title: 'Төлөв',
    key: 'sequence',
    width: 100,
    render: (item: any, _: any, index: any) => {
      return <Tag color={statusTagColor(item?.status?.code)}>{item?.status?.name}</Tag>;
    },
  },
  {
    key: 'rowIndex',
    width: 150,
    align: 'center',
    render: (item: any, _: any, index: any) => (
      <Button onClick={() => setType(item?.id!)} type="default">
        Дэлгэрэнгүй
      </Button>
    ),
  },
];

const Container = styled.div`
  .ant-btn-color-primary {
    background-color: ${Colors.blue} !important;
  }
  .ant-tabs-tab {
    margin: 0 5px !important;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 30px;
  margin-bottom: 10px;

  label {
    font-size: 18px;
    font-weight: 600;
  }
`;

export { ValuationTaskScreen };
